import React from 'react';

/**
 * Standby's mark, copied exactly from the app's own header
 * (standby/packages/frontend/.../header/Header.component.tsx): a 64-unit box
 * with three r=9 circles at x 12 / 32 / 52. The teal one is hardcoded and the
 * other two take currentColor, the third at 30% — so the mark follows whatever
 * it sits on, which is how the app swaps it between light and dark.
 *
 * The geometry matters. An earlier version approximated it on a 20-unit box
 * with r=2.4, which spaced the dots differently and read as a near relation
 * rather than the same logo when the two were seen together.
 *
 * Pair it with `font-display` (Syne) bold at an 8px gap to reproduce the full
 * lockup — both sites map font-display to Syne, so the wordmark already
 * matches without any extra work.
 */
export const StandbyMark: React.FC<{ size?: number }> = ({ size = 20 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
  >
    <circle cx="12" cy="32" r="9" fill="#0ea5c9" />
    <circle cx="32" cy="32" r="9" fill="currentColor" />
    <circle cx="52" cy="32" r="9" fill="currentColor" opacity="0.3" />
  </svg>
);

export default StandbyMark;
